import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBDateField, CopyButton } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';
import { PatientCareCenterNoteNavAnchor } from '../../NavAnchor';

class PatientCareCenterNoteGoalsLTGDetails extends React.Component {

    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }


    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGPNO', this.props.goal.GOGPNOPREV);
    }


    render() {
        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.goal.GONO} >
                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_col1}>
                        {(this.props.noteType === 1 || this.props.noteType === 4 || this.props.noteType === 3|| this.props.noteType === 5 || this.props.noteType === 6) &&
                            <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                        }
                    </span>
                    {/* Activity */}
                    <div className={styles.ltg_activity}>
      
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOOBJECTIVE'
                            className={this.props.descReq ? styles.text_field_req : styles.text_field}
                            disabled={this.props.noteType === 2}
                            placeholder='Describe or quantify goal'
                        />
                
                    
                    </div>
                    
                    {/* PROGRESS */}
                    {this.props.noteType !== 1 &&
                        <>
                            <span className={styles.goal_detail_prog_dropdown_stg}>
                                <DBDropDown
                                    className={this.props.progReq ? styles.ltg_goal_prog_dropdown_req : styles.ltg_goal_prog_dropdown}
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.goal.GONO}
                                    field='GOGPNO'
                                    masterEntity='PTMASTERGOALPROGRESS'
                                    masterEntityKeyColumn='GPNO'
                                    masterEntitySort='GPORDER'
                                    masterEntityDisplay='GPNAME'
                                    disabled={this.props.progDisabled}
                                    onChange={() => this.goalValueChanged()}
                                />
                            </span>
                            {(this.props.noteType === 3 || this.props.noteType === 5) ? 
                            (
                                <div className={styles.goal_detail_copy_col}>
                                    <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                                </div>) 
                                :( <span className={styles.goal_detail_copy_col}/>)
                            }
                        </>
                    }
                    {/* DATE */}
                    <div className={styles.stg_date}>
                        <span className={styles.date_field}>
                        
                             <DBDateField
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.goal.GONO}
                                    maxDate={new Date().setFullYear(new Date().getFullYear() + 1)}
                                    field='GODATE'
                                    disabled={this.props.noteType === 2}
                                    customMsg='The goal date cannot be in the past.'
                                    minDate={getDateMMDDYYYY(new Date())}
                                    defaultdate={this.props.days}
                                    required={this.props.dateReq}
                                />
                        </span>
                    </div>

                       

                </div>
                <div>
                {this.props.noteType !== 1 &&
                 <>
                       {/* CLOF */}
                       <div className={styles.clof_wrapper}>
                            <span className={styles.clof_label}>
                                CLOF: 
                            </span>
                                <DBTextField
                                    className={styles.clof}
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.goal.GONO}
                                    field='GOCLOFTXT'
                                    placeholder='Describe or quantify CLOF'
                                />
                           </div>
                 </>
                }
                </div>
            </PatientCareCenterNoteNavAnchor>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;
    let descReq = (noteType === 1 || noteType === 3 || noteType === 5) && !goal.GOOBJECTIVE ? true : false;
    let days = ownprops.days;
    let dateReq = noteType !== 2 && !goal.GODATE ? true : false;
    let defaultDate = ownprops.days ?? 0;
    let progReq = !goal.GOGPNO ? true : false;
    let goalPreviouslyMet = false;
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    if (state.entities.notes.PTGOALS[ownprops.id].GOGPNOPREV === 11) {
        goalPreviouslyMet = true;
    }
    let clofReq = noteType !== 2 && !goal.GOCLOF ? true : false;

    let pdcDisabled = false;
    let isWc = state.entities.admissions[epno].isWc;
    if (noteType === 1 && !state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC && isWc) {
        pdcDisabled = true;
    }

    let activityDisabled = goal.GOGONO || goalPreviouslyMet || pdcDisabled ? true : false;
    let clofDisabled = noteType === 2 || goalPreviouslyMet || pdcDisabled ? true : false;
    let clofGoalLevels = [];
    if (goal.GOMGNO) {
                // get based on XREF
         let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
         .filter(key => {
             return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
         })
         .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);
    
        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
        .filter(key => {
            return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
        })
        .sort((a, b) => {
            let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                .find(key => {
                    return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                        state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                });
            let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

            let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                .find(key => {
                    return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                        state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                });
            let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

            return aOrder - bOrder;
        })
        .map(key => {
            return {
                id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
            }
        })
    }
    return {
        noteId,
        progReq,
        clofReq,
        noteType,
        clofGoalLevels,
        pk,
        descReq,
        dateReq,
        goal,
        goalsUpdated,
        isPrevGoal: goal.GOGONO ? true : false,
        defaultDate,
        activityDisabled,
        days,
        clofDisabled
    };
}

const connectedPatientCareCenterNoteGoalsLTGDetails = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsLTGDetails);
export { connectedPatientCareCenterNoteGoalsLTGDetails as PatientCareCenterNoteGoalsLTGDetails };

